import moment from 'moment';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Input, Switch, Textarea } from 'rizzui';
import useFetch from '../../../../../hooks/useFetch';
import FormGroup from '../../../../../layout/shared/form-group';
import { RouteService } from '../../../../../services/route/routeService';
import { RouteApiResponse } from '../../../../../type/entities/route-type';

interface RouteInfoProps { }

const RouteInfo: React.FC<RouteInfoProps> = () => {

    // HOOKS

    const { id = '' } = useParams<{ id: string }>();
    const service = new RouteService();

    // DATA FETCHING

    // -----------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LOS DATOS DE LA RUTA POR ID
     * @EN GETS THE ROUTE DATA BY ID
     */
    // -----------------------------------------------------------------------------------------------------
    const [data, loading] = useFetch(useCallback(async () => {
        if (!id || id === '') return null;
        const response = await service.getRouteById(id);
        return response.getResponseData() as RouteApiResponse;
    }, [id]));
    // -----------------------------------------------------------------------------------------------------

    // RENDER

    return (
        <>
            <div className="@container">
                <div className="grid gap-7 divide-y-2 divide-dashed divide-gray-200">
                    <FormGroup
                        title="Información General"
                        description="Datos principales de la ruta"
                        className='pt-4'
                        titleCols="@md:col-span-2"
                        childCols="@md:col-span-10 md:grid-cols-4"
                    >
                        <Input
                            disabled
                            label="Nombre"
                            className="col-span-4 md:col-span-2"
                            placeholder="Nombre de la ruta"
                            value={data?.name ?? ""}
                        />
                        <Input
                            disabled
                            label="Estado"
                            className="col-span-4 md:col-span-2"
                            value={data?.status ? 'Activa' : 'Inactiva'}
                        />
                        <Input
                            disabled
                            label="Radio de inclusión"
                            className="col-span-4 md:col-span-2"
                            value={data?.radioInclusion}
                        />
                        <Input
                            disabled
                            label="Fecha de creación"
                            className="col-span-4 md:col-span-2"
                            placeholder='Fecha creación'
                            value={data?.createdAt ? moment(data.createdAt?.date).format('DD/MM/YYYY') : ''}
                        />
                        <Input
                            disabled
                            label="Fecha de actualización"
                            className="col-span-4 md:col-span-2"
                            placeholder='Sin Actualizar'
                            value={data?.updatedAt ? moment(data.updatedAt?.date).format('DD/MM/YYYY') : ''}
                        />

                        <Switch
                            id="status"
                            label={data?.status === 'active' ? 'Ruta activa' : 'Ruta inactiva'}
                            checked={data?.status === 'active'}
                            switchClassName='pointer-events-none'
                        />

                        {data?.description && (
                            <Textarea
                                disabled
                                className='col-span-4'
                                label="Descripción"
                                value={data.description}
                            />
                        )}

                    </FormGroup>

                    {data?.company && (
                        <FormGroup
                            title="Organización"
                            description="Datos de la organización"
                            className='pt-4'
                            titleCols="@md:col-span-2"
                            childCols="@md:col-span-10 md:grid-cols-3"
                        >
                            <Input
                                disabled
                                label="Nombre"
                                placeholder="Nombre de la organización"
                                value={data.company.name ?? ""}
                            />
                            <Input
                                disabled
                                label="CIF"
                                value={data.company.cif ?? ""}
                            />
                            <Input
                                disabled
                                label="Dirección"
                                value={data.company.address ?? ""}
                            />
                        </FormGroup>
                    )}
                </div>
            </div>
        </>
    );
};

export default RouteInfo;